import { upsertCompany } from '@dispatch/shared/services';
import { Company } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export const useUpsertCompany = (
  onSuccess: ({ success }: { success: boolean; message?: string }) => void
) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['upsert-company'],
    async (data: Partial<Company>) => upsertCompany(data),
    {
      onSuccess,
      onSettled: () => {
        client.invalidateQueries(['company']);
        client.invalidateQueries(['current-company']);
      },
    }
  );

  return {
    upsertCompany: mutate,
    error,
    status,
  };
};
